import { render, staticRenderFns } from "./Trusted.vue?vue&type=template&id=073ccbf8&scoped=true&"
import script from "./Trusted.vue?vue&type=script&lang=js&"
export * from "./Trusted.vue?vue&type=script&lang=js&"
import style0 from "./Trusted.vue?vue&type=style&index=0&id=073ccbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ccbf8",
  null
  
)

export default component.exports